var path = '/app/components/dialogs/interview/interview.html';
var html = "<div class=custom-modal-wrap> <div class=custom-modal> <div class=modal-body id=modal-body> <div class=\"btn-sound {{$ctrl.soundStatus}}\" ng-click=$ctrl.toggleSound()></div> <div class=btn-close ng-click=$ctrl.cancel()></div> <interview-ballon key=\"($index + 1)\" audio=\"{{ step.audio }}\" ng-show=\"$ctrl.state.step === ($index + 1)\" type=\"{{ step.key }}\" text=\"{{ step.value }}\" sound=$ctrl.soundStatus ng-repeat=\"step in $ctrl.state.steps\" after-close=$ctrl.onSubmitBallon()></interview-ballon> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/interview/interview.html
// module id = 148
// module chunks = 0